<div class="cargo-dialog-container">
	<h2 mat-dialog-title>{{ titleTranslationKey | translate }}</h2>
	<div mat-dialog-content>
		<div class="loading-indicator" *ngIf="isLoading">
			<cass-indeterminate-circular-progress-indicator></cass-indeterminate-circular-progress-indicator>
		</div>
		<div [hidden]="isLoading" class="cargo-iframe-container">
			<iframe #cargoIframe class="cargo-iframe" [src]="cargoUrl"></iframe>
		</div>
	</div>
</div>

